module.exports = __webpack_public_path__ + "static/media/firma.a3f2f882.svg";